export default __webpack_public_path__ + "images/Christmas_Display.webp?27dee8bbd3b503e25bfa79159b18cfd3";